import { assetUrl } from "./backend";
import { thumbUrl } from "./thumb";

/** 原图静态 URL（由 Nginx 直接提供） */
export function imageStaticUrl(relativePath: string): string {
  const path = relativePath.replace(/^\/+/, "");
  if (!path) return "";
  return assetUrl(path);
}

/** 缩略图静态 URL（预生成的 _缩略图.jpg，由 Nginx 直接提供） */
export function thumbStaticUrl(relativePath: string): string {
  const path = relativePath.replace(/^\/+/, "");
  if (!path) return "";
  return thumbUrl(path);
}

/** @deprecated blob URL 管理，静态 URL 模式下无需释放 */
export function revokeAssetBlobUrl(_url: string): void {
  /* no-op: 静态 URL 无需 revoke */
}

export interface FetchImageOptions {
  thumbnail?: boolean;
  maxEdge?: number;
  quality?: number;
}

/**
 * 返回可用于 img src 的静态 URL（不再 POST /api/get-image）。
 */
export async function fetchImageObjectUrl(
  relativePath: string,
  options: FetchImageOptions = {}
): Promise<string> {
  const path = relativePath.replace(/^\/+/, "");
  if (!path) return "";
  if (options.thumbnail) {
    return thumbStaticUrl(path);
  }
  return imageStaticUrl(path);
}

export interface BatchImagesResult {
  images: Record<string, string>;
  errors: Record<string, string>;
}

/**
 * 批量返回缩略图静态 URL（不再 POST /api/get-images）。
 */
export async function batchFetchImageDataUrls(
  paths: string[],
  _options: FetchImageOptions = {}
): Promise<BatchImagesResult> {
  const unique = [...new Set(paths.map((p) => p.replace(/^\/+/, "")).filter(Boolean))];
  const images: Record<string, string> = {};
  unique.forEach((p) => {
    images[p] = thumbStaticUrl(p);
  });
  return { images, errors: {} };
}

/** 先缩略后高清：返回 { thumb, full } 静态 URL */
export async function fetchProgressivePair(
  relativePath: string,
  _options?: { thumbMaxEdge?: number; fullMaxEdge?: number }
): Promise<{ thumb: string; full: string }> {
  const path = relativePath.replace(/^\/+/, "");
  return {
    thumb: thumbStaticUrl(path),
    full: imageStaticUrl(path),
  };
}
